import { css } from 'emotion';
import { COLORS } from '../../_shared/styles/colors';

export const cardMainStyles = css({
	minHeight: 250,
	borderRadius: 10,
});

export const candidateNameStyles = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: '600 !important',
	color: COLORS.hyperLink,
	fontSize: 18,
	marginBottom: 0,
	lineHeight: 1,
	paddingBottom: 5,
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
});

export const referrerNameStyles = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: '600 !important',
	color: COLORS.blue,
	fontSize: 14,
});

export const miscTextStyles = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: 400,
	color: COLORS.heading,
	fontSize: 14,
	textAlign: 'right',
	width: 150,
});

export const miscTextColStyles = css({
	textAlign: 'right',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
});

export const statusTextStyles = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: 500,
	color: COLORS.blue,
	fontSize: '15px',
});

export const statusStyles = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: 500,
	color: COLORS.textSecondaryNeutral,
	fontSize: 15,
});

export const dropdownMenuItem = css({
	borderColor: 'transparent',
	color: COLORS.blue,
	'&:hover': {
		backgroundColor: COLORS.white,
		color: COLORS.blue,
		borderColor: 'transparent',
	},
});

export const dropdownButton = (width) =>
	css({
		marginLeft: 8,
		borderColor: 'transparent',
		color: COLORS.blue,
		'&:hover': {
			backgroundColor: COLORS.white,
			color: COLORS.blue,
			borderColor: 'transparent',
		},
		'&:focus': {
			backgroundColor: COLORS.white,
			color: COLORS.blue,
			borderColor: COLORS.white,
		},
		width,
	});

export const BonusAmount = css({
	color: COLORS.green,
	textAlign: 'right',
	marginTop: -15,
});

export const linkStyles = css({
	fontWeight: '600 !important',
	color: COLORS.hyperLink,
});

export const ModalStyles = css({
	'& .ant-modal-content': {
		borderRadius: 10,
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: COLORS.blue,
	},
	'& .ant-modal-close': {
		display: 'none',
	},
	fontFamily: 'Open Sans',
	width: 620,
});

export const tableHeader = css({
	fontFamily: '"Open Sans", sans-serif !important',
	fontWeight: '600 !important',
});

export const successStyles = css({
	width: 250,
	position: 'fixed',
	top: 300,
	left: 480,
});

export const locationStyle = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: 400,
	color: COLORS.darkGray,
	fontSize: 14,
	marginRight: 5,
});

export const referrerNameStylesBlue = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: '600 !important',
	color: COLORS.blue,
	fontSize: 14,
	marginBottom: 0,
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

export const Department = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: 400,
	color: COLORS.darkGray,
	fontSize: 14,
	marginLeft: 5,
	marginRight: 5,
});

export const companyNameText = css({
	fontFamily: '"Open Sans", sans-serif',
	fontWeight: '500 !important',
	color: COLORS.textSecondaryNeutral,
	fontSize: 15,
	marginTop: 2,
	maxWidth: 205,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	display: '-webkit-box',
	lineHeight: '22px',
	maxHeight: '44px',
	'-webkit-line-clamp': 2,
	'-webkit-box-orient': 'vertical',
	whiteSpace: 'pre-wrap',
});
